import isFunction from 'lodash-es/isFunction';
import isNil from 'lodash-es/isNil';
import isObject from 'lodash-es/isObject';

import { DeepMapKeys, type MapFn, type Opts } from './deep-map-keys';

/**
 * Local implementation of deepMapKeys NPM package
 * https://www.npmjs.com/package/deep-map-keys
 * The original package is using non tree-shakable Lodash, which exposes itseslf to the window
 * and it can lead to confiltcts with other libraries when used in the Editor.
 
 */

export function deepMapKeys<T>(object: any, mapFn: MapFn, options?: Opts): T {
  options = isNil(options) ? {} : options;

  if (!mapFn) {
    throw new Error('mapFn is required');
  }
  if (!isFunction(mapFn)) {
    throw new TypeError('mapFn must be a function');
  }
  if (!isObject(options)) {
    throw new TypeError('options must be an object');
  }

  return new DeepMapKeys(mapFn, options).map(object);
}
